/* eslint-disable @typescript-eslint/camelcase */
export class AddDraftReceiptApiRequest {
  customerId: number;
  customerType: string;
  customerName: string;
  customerPhone: string;
  bookingDateFrom: string;
  bookingDateTo: string;
  sttTypes: Array<string>;
  serviceTypes: Array<string>;
  additionalStt: Array<string>;

  constructor(
    customerId: number,
    customerType: string,
    customerName: string,
    customerPhone: string,
    bookingDateFrom: string,
    bookingDateTo: string,
    sttTypes: Array<string>,
    serviceTypes: Array<string>,
    additionalStt: Array<string>
  ) {
    this.customerId = customerId;
    this.customerType = customerType;
    this.customerName = customerName;
    this.customerPhone = customerPhone;
    this.bookingDateFrom = bookingDateFrom;
    this.bookingDateTo = bookingDateTo;
    this.sttTypes = sttTypes;
    this.serviceTypes = serviceTypes;
    this.additionalStt = additionalStt;
  }

  toJSON(): string {
    return JSON.stringify({
      customer_id: this.customerId,
      customer_type: this.customerType,
      customer_name: this.customerName,
      customer_phone: this.customerPhone,
      booking_date_from: this.bookingDateFrom,
      booking_date_to: this.bookingDateTo,
      stt_types: this.sttTypes,
      service_types: this.serviceTypes,
      additional_stt: this.additionalStt
    });
  }
}
